import { render, staticRenderFns } from "./logistics.vue?vue&type=template&id=44900ddd&scoped=true&"
import script from "./logistics.vue?vue&type=script&lang=js&"
export * from "./logistics.vue?vue&type=script&lang=js&"
import style0 from "./logistics.vue?vue&type=style&index=0&lang=css&"
import style1 from "./logistics.vue?vue&type=style&index=1&id=44900ddd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44900ddd",
  null
  
)

export default component.exports